import React from 'react';
import styled from 'styled-components';
import ErrorResponse from '../../../../acropolisCommon/components/ErrorResponse';
import { Text } from '../../../../acropolisCommon/components/Texts';
import useActivity from '../../../hooks/useActivity';
import parse from 'html-react-parser';
import DefaultChip from '../../../../acropolisCommon/components/DegaultChip';
import CommonButton from '../../../../../components/common/CommonButton';

const ViewPresentation = (props) => {
    const { resource } = props;

    const [presentation] = useActivity(resource?.id_evaluacion);

    if (!presentation) {
        return <ErrorResponse />;
    }

    const {
        name,
        descripcion,
        tipo_entrega,
        opciones_entrega,
        consigna,
        scorm_manager_preview_url,
    } = presentation;
    const previewScormUrl =
        scorm_manager_preview_url &&
        scorm_manager_preview_url.replace('/view/', '/preview/');

    const handleScormPreview = () => {
        window.open(previewScormUrl);
    };

    return (
        <DisplayWrapper>
            <ContentChip>
                <DefaultChip
                    padding="15px"
                    radius="15px"
                    textColor="#fff"
                    color="#b31d15"
                    title={tipo_entrega}
                />
                <DefaultChip
                    radius="15px"
                    textColor="#fff"
                    color="#b31d15"
                    title={opciones_entrega}
                />
            </ContentChip>
            <Text color="#616161" fontWeight="bold" fontSize="18px">
                {name?.toUpperCase()}
            </Text>
            <Description>
                <Text color="#616161" fontWeight="bold">
                    Descripcion de actividad:
                </Text>
                <RenderHTML>{parse(descripcion)}</RenderHTML>
                <Text color="#616161" fontWeight="bold">
                    Consigna:
                </Text>
                <RenderHTML>{parse(consigna)}</RenderHTML>
                {scorm_manager_preview_url && (
                    <CommonButton
                        label="Ver Actividad SCORM"
                        variant="outlined"
                        onClick={handleScormPreview}
                    />
                )}
            </Description>
        </DisplayWrapper>
    );
};

export default ViewPresentation;

const DisplayWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const Description = styled.div`
    display: flex;
    flex-direction: column;
`;

const RenderHTML = styled.div`
    margin: 16px 0;
`;

const ContentChip = styled.div`
    display: flex;
    gap: 12px;
`;
